import { render } from "./Imprint.vue?vue&type=template&id=07dd0818&scoped=true"
import script from "./Imprint.vue?vue&type=script&lang=js"
export * from "./Imprint.vue?vue&type=script&lang=js"

import "./Imprint.vue?vue&type=style&index=0&id=07dd0818&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-07dd0818"

export default script